import { useState } from "react";
import tools, { toolsArray } from "../Tools";
import { SYSTEM_PROMPT } from "../constants";
import useChatCompletion from "./useChatCompletion";

const MAX_ITERATIONS = 20;

const useToolCalls = () => {
  const [messages, setMessages] = useState([
    { role: "system", content: SYSTEM_PROMPT },
  ]);
  const [chat, setChat] = useState([
    {
      role: "assistant",
      content: JSON.stringify({
        response: "Hello! How can I assist you today?",
        is_table: false,
        table: null,
        need_input: false,
        input_fields: null,
        is_list: false,
        list: null,
        is_confirmation: false,
        confirmation: null,
      }),
      refusal: null,
    },
  ]);
  const [isFetching, setIsFetching] = useState(false);
  const { fetchResponse } = useChatCompletion();

  const fetchChatResponse = async (conversationHistory, tempChat) => {
    setIsFetching(true);
    for (let i = 0; i < MAX_ITERATIONS; i++) {
      try {
        const response = await fetchResponse(conversationHistory, toolsArray);
        if (!response || response.errorMessage) {
          tempChat.push({
            role: "assistant",
            content: response.errorMessage,
            isError: true,
          });
          setChat([...tempChat]);
          setIsFetching(false);
          return;
        }

        const { finish_reason: finishReason, message } =
          response.data.choices[0];
        const { tool_calls: toolCalls } = message;

        conversationHistory.push(message);
        setMessages([...conversationHistory]);

        if (finishReason === "stop") {
          tempChat.push(message);
          setChat([...tempChat]);
          setIsFetching(false);
          return;
        } else if (finishReason === "tool_calls") {
          for (const toolCall of toolCalls) {
            const functionName = toolCall.function.name;
            const functionToCall = tools[functionName];
            const functionArgs = JSON.parse(toolCall.function.arguments);
            const functionResponse = await functionToCall(functionArgs);

            conversationHistory.push({
              tool_call_id: toolCall.id,
              role: "tool",
              name: functionName,
              content: functionResponse,
            });

            setMessages([...conversationHistory]);
          }
        }
      } catch (error) {
        console.error("Error fetching AI response:", error);
        setMessages([
          ...messages,
          {
            role: "assistant",
            content: "Something went wrong. Try again later!",
          },
        ]);
        setIsFetching(false);
        return;
      }
    }
  };

  return {
    messages,
    chat,
    isFetching,
    fetchChatResponse,
    setMessages,
    setChat,
  };
};

export default useToolCalls;
